import request from 'utils/request_ajax';
import { TYPES, routes as ROUTES } from '../../constants/config';
import { PATH_BUILDER } from '../../constants/actionTypes';

export function createTagging(tag) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const { id: pathId } = getState().pathBuilder;
      const taggingData = {
        taggableId: pathId,
        taggableType: TYPES.PATH,
        tagId: tag.id,
      };
      request
        .postJSON(ROUTES.TAGGINGS, { tagging: taggingData })
        .then(tagging => {
          dispatch({
            type: PATH_BUILDER.TAGGING.CREATE,
            tagging,
          });
        });
    });
}

export function removeTagging(tagging) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      request.delete(ROUTES.TAGGING(tagging.id)).then(() => {
        dispatch({
          type: PATH_BUILDER.TAGGING.REMOVE,
          taggingId: tagging.id,
        });
      });
    });
}

export function tagAllContent(tagging) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const { id: pathId } = getState().pathBuilder;
      request
        .postJSON(ROUTES.TAG_ALL_CONTENT, {
          tagId: tagging.tag.id,
          pathId,
        })
        .then(() => {
          // eslint-disable-next-line no-alert
          alert('Tagged all content with ' + tagging.tag.name);
        });
    });
}
